<template>
  <div class="approval-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <!--<div class="header-btn-box">-->
        <!--<a @click="modify" v-if="!modifyState">修改</a>-->
      <!--</div>-->
    </div>
    <form>
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <div style="border-left: 3px solid #00a0e6;padding: 0 5px;">销方配置</div>
        <div class="header-btn-box">
          <a @click="modify" v-if="!modifyState">修改</a>
          <a @click="cancel" v-if="modifyState">取消</a>
          <a @click="confirm" v-if="modifyState">确定</a>
        </div>
      </div>
      <div class="form-main">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">销方ID：</span>
          </div>
          <el-input v-model="resellerId" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">销方名称：</span>
          </div>
          <el-input v-model="resellerName" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">纳税人识别号：</span>
          </div>
          <el-input v-model="taxPayerIdentificationNumber" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">地址：</span>
          </div>
          <el-input v-model="address" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">电话：</span>
          </div>
          <el-input v-model="phone" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开户行：</span>
          </div>
          <el-input v-model="bank" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">账号：</span>
          </div>
          <el-input v-model="accountNumber" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票人：</span>
          </div>
          <el-input v-model="issuer" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">审核人：</span>
          </div>
          <el-input v-model="reviewer" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">收款人：</span>
          </div>
          <el-input v-model="payee" size="small" :disabled="!modifyState" style="width: 280px" />
        </div>
      </div>

      <div style="display: flex;justify-content: space-between;align-items: center;">
        <div style="border-left: 3px solid #00a0e6;padding: 0 5px;">消息接收人配置</div>
        <div class="header-btn-box">
          <a @click="modifyPerson" v-if="!personModifyState">修改</a>
          <a @click="cancelPerson" v-if="personModifyState">取消</a>
          <a @click="confirmPerson" v-if="personModifyState">确定</a>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">接收人：</span>
        </div>
        <el-select v-model="personCode" :disabled="!personModifyState" size="small" style="width: 330px" multiple>
          <el-option v-for="item in personList" :key="item.code"
                     :label="item._label" :value="item.code">
          </el-option>
        </el-select>
      </div>

    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/invoice'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import TextTitle from '../../../components/Text/TextTitle'

  export default {
    components: {
      TextTitle,
      ButtonConfirm,
      ButtonCancel,
      TableMain,
      InputSearch,
      ButtonAdd,
      Breadcrumb},
    name: 'agent-config',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧凭证',
          name: 'invoice-over-view'
        }, {
          value: '开票配置'
        }],
        mainTitle: '配置管理',
        subheading: '',

        resellerId: '',
        resellerName: '',
        taxPayerIdentificationNumber: '',
        address: '',
        phone: '',
        bank: '',
        accountNumber: '',
        issuer: '',
        reviewer: '',
        payee: '',
        isDisplayReleaseRoomOnPage: false,
        configData: {},
        modifyState: false,

        personModifyState: false,
        personList: [],
        personCode: []
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getResponsible()
      this.getConfiguration()
      this.getMessageReceiverPersonList()
    },
    methods: {
      // 查询销方配置
      getConfiguration () {
        this.$axios.get(`${api.getConfiguration}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                this.resellerId = data.resellerId
                this.resellerName = data.resellerName
                this.taxPayerIdentificationNumber = data.taxPayerIdentificationNumber
                this.address = data.address
                this.phone = data.phone
                this.bank = data.bank
                this.accountNumber = data.accountNumber
                this.issuer = data.issuer
                this.reviewer = data.reviewer
                this.payee = data.payee
              }
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 点击修改
      modify () {
        this.modifyState = true
      },

      // 取消修改
      cancel () {
        this.modifyState = false
        this.getConfiguration()
      },

      // 修改
      confirm () {
        this.$axios.post(api.saveOrUpdateConfiguration, {
          resellerId: this.resellerId,
          resellerName: this.resellerName,
          taxPayerIdentificationNumber: this.taxPayerIdentificationNumber,
          address: this.address,
          phone: this.phone,
          bank: this.bank,
          accountNumber: this.accountNumber,
          issuer: this.issuer,
          reviewer: this.reviewer,
          payee: this.payee,
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.modifyState = false
              this.getConfiguration()
            }
          })
          .catch(errorHandler('修改失败'))
      },

      // 查询接收人
      getMessageReceiverPersonList () {
        this.$axios.get(`${api.getMessageReceiverPersonList}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                this.personCode = []
                data.map(v => {
                  this.personCode.push(v.personCode)
                })
              }
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 获取接收人列表
      getResponsible () {
        this.$axios.post(api.getResponsiblePersonList, {})
          .then(res => {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone}`
            })
            this.personList = list
          })
          .catch(errorHandler('获取接收人列表失败'))
      },

      // 点击修改
      modifyPerson () {
        this.personModifyState = true
      },

      // 取消修改
      cancelPerson () {
        this.personModifyState = false
        this.getMessageReceiverPersonList()
      },

      // 修改
      confirmPerson () {
        let personArr = []
        this.personList.map(person => {
          this.personCode.map(v => {
            if (v === person.code) {
              let personObj = {
                personCode: person.code,
                personName: person.name,
                personPhone: person.phone,
                wxOpenid: person.wxOpenIdForMp,
              }
              personArr.push(personObj)
            }
          })
        })
        this.$axios.post(api.reselectReceiverMessageReceiverPersonList, personArr)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.personModifyState = false
              this.getMessageReceiverPersonList()
            }
          })
          .catch(errorHandler('修改失败'))
      },
    },
    watch: {}
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-main {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
  }
  .form-line {
    margin: 10px 20px 10px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 300px;
    /*padding: 0 124px;*/
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>
<style lang="less">
  .approval-manage {
    .approvalBox {
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Invoice/InvoiceConfig/InvoiceConfig.vue